import React from 'react';
import logo75 from '../assets/images/75Years.png';
import logo from '../assets/images/logo.png';
const ImmediateTests = ({ data }) => {
    const {
        DietRecommendationList = [],
        LifeStyleList = [],
        patientDetails = {},
    } = data?.data || {};
    
    const isDietAndLifestyleEmpty = DietRecommendationList.length === 0 && LifeStyleList.length === 0;

    const immidiateTest = (data?.data?.RecommendationList || []);
    const immidiateTestPriorty = immidiateTest.sort((a, b) => a.Priority - b.Priority);
    return (
        <>
            {immidiateTestPriorty && immidiateTestPriorty.length > 0 ? (

                <>
                    <section className="section section-6 " id="test-recomendation">
                        <div className="container">


                            <div className="row">
                                <div className="col d-flex align-items-center pt-2 pb-2 header">
                                    <div>
                                        <img className="img-fluid logo-75" src={logo75} />
                                    </div>
                                    <div className="ms-auto">
                                        <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="container-1 benefits">
                                    <div className="col-12 mt-2 mb-5 text-center"><h2 className="panel-name"> Test recommendations </h2></div>

                                   { isDietAndLifestyleEmpty && (
                                    <div className="col-12 mb-2">
                                        <h2 className="sub-title">Hello {patientDetails.PatientName},</h2>
                                    </div>
                                    )}
                                    <div className="col-12 desc" style={{ marginBottom: 10 + 'px', fontWeight: 500 }}>
                                        Based on the tests conducted, here are some suggested follow-ups and additional tests that would be beneficial for you :
                                    </div>

                                    {/* <div className="col-12">
                        <span className="recom-tile">Immediate  <span>Tests</span></span>
                    </div> */}
                                    <div className="col-12">
                                        <div className="row justify-content-center recomandation-wrapper1 with-bottom-button">

                                            {immidiateTestPriorty.map((test, index) => {
                                                const imageName = test.TestName.toLowerCase().replace(/\s+/g, '-') + '.webp';
                                                const imageUrl = `${test.ImageUrl}${imageName}`;
                                                return (
                                                    <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 d-flex" >
                                                        <div className="card-wrapper" id={test.TestCode}>
                                                            {/* <div className="rec-image-wrapper">
                                                <img alt={test.TestName} src={imageUrl} />
                                            </div> */}
                                                            <h2 className="rec-title">{test.TestName}</h2>
                                                            <div className="rec-desc mb-md-3">
                                                                {test.TestDescription}
                                                            </div>
                                                            <div className="button-area mt-4">
                                                                <a href={test.KnowMoreUrl} target='_blank' className="btn btn-yellow">Know More</a>
                                                                <a href={test.BookNowUrl} target='_blank' className="btn btn-blue">Book Now</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (' ')}
        </>
    )
}

const FollowUpTests = ({ data }) => {
    const followupTest = (data?.data?.FollowUpList || []);
    return (
        <>
            {followupTest && followupTest.length > 0 ? (
                <>
                    <div className="col-12 mt-5">
                        <span className="recom-tile">Follow-up  <span>Tests</span></span>
                    </div>
                    <div className="col-12">
                        <div className="row justify-content-center recomandation-wrapper1 with-bottom-button">
                            {followupTest.map((ftest, index) => {
                                const imageName = ftest.TestName.toLowerCase().replace(/\s+/g, '-') + '.webp';
                                const imageUrl = `${ftest.ImageUrl}${imageName}`;
                                return (
                                    <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 d-flex" >
                                        <div className="card-wrapper " id={ftest.TestCode}>
                                            {/* <div className="rec-image-wrapper">
                                                <img alt="" src={imageUrl} />
                                            </div> */}
                                            <h2 className="rec-title">{ftest.TestName}</h2>
                                            <div className="rec-desc mb-md-3">
                                                {ftest.TestDescription}
                                            </div>
                                            <div className="button-area mt-4">
                                                <a href={ftest.KnowMoreUrl} target='_blank' className="btn btn-yellow">Know More</a>
                                                <a href={ftest.BookNowUrl} target='_blank' className="btn btn-blue">Book Now</a>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                    <div className="col-12 mb-0">
                        <div style={{ marginTop: 0 + 'px', fontSize: 13 + 'px', lineHeight: 140 + '%' }}>
                            Immediate tests and follow-ups are essential for monitoring your health, detecting early disease signs, and guiding necessary lifestyle adjustments.
                        </div>
                    </div>
                </>
            ) : (' ')}


        </>
    )
}


export { ImmediateTests, FollowUpTests };